export const getMetricTitle = metric => (!metric ||
                        !metric.screen_element ||
                        !metric.screen_element.title ? "" : metric.screen_element.title.toLowerCase());

export const isInGuestMetricList = (metrics, metricId) => {
  if (!metrics || metrics.length === 0) {
    return false;
  }

  return metrics.some(x => x.screenElementId === metricId);
};

export const shouldUpdateFilter = (prevProps, prevState, props, state) => {
  const { searchText, filteredMetrics } = state;
  const { deal, guestPermission } = props;

  return prevState.searchText !== searchText ||
      (!prevProps.deal && Boolean(deal)) ||
      prevProps.guestPermission !== guestPermission ||
      filteredMetrics.length === 0;
};
